const ORBS = [
  {
    className:
      'top-[-12%] left-[-8%] h-[42rem] w-[42rem] bg-violet-500/30 mix-blend-screen',
    delay: '0s',
  },
  {
    className:
      'top-[18%] right-[-14%] h-[36rem] w-[36rem] bg-cyan-400/25 mix-blend-screen',
    delay: '-7s',
  },
  {
    className:
      'bottom-[-18%] left-[28%] h-[40rem] w-[40rem] bg-fuchsia-500/20 mix-blend-screen',
    delay: '-13s',
  },
];

function BackgroundOrbs() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-ink-950 via-ink-900 to-ink-950" />
      <div className="grid-overlay absolute inset-0 opacity-60" />
      {ORBS.map((orb) => (
        <div
          key={orb.className}
          className={`absolute rounded-full blur-[120px] animate-orb-drift ${orb.className}`}
          style={{ animationDelay: orb.delay }}
        />
      ))}
      <div className="absolute inset-0 noise" />
    </div>
  );
}

export default BackgroundOrbs;